import { Route } from 'react-router-dom';

import {
  ADMIN_QUESTIONS,
  ADMIN_REASONCODES,
  ADMIN_REUSABLECOMPONENTS,
  ADMIN_TASKTYPES,
  INTERNAL_TIME_OFFICE,
  TASKS_ROUTE,
  CALENDAR_ROUTE,
  WORKPLAN_ROUTE,
  MAP_TASK_LIST_ROUTE,
  ADMIN_PORTAL_LINKS,
  TECHNICIAN_TASKLIST_ROUTE,
  ADMIN_NEWS,
  ADMIN_DEPARTMENTS,
  ADMIN_UPDATE_TASK_STATUS,
  DEV_INBOX,
  DEV_OUTBOX
} from './utils/constants';

import WorkPlanCalendarView from './views/task-view/calendar-view/CalendarView';
import InternalTimeOfficeView from './views/internal-time-office-view/InternalTimeOfficeView';
import AdminTaskTypesView from './views/admin/admin-task-types/AdminTaskTypesView';
import AdminReusableComponentsView from './views/admin/admin-reusable-components/AdminResusableComponentsView';
import AdminReasonCodesView from './views/admin/admin-reasoncodes-view/AdminReasonCodesView';
import AdminChecklistQuestionView from './views/admin/admin-checklist-questions-view/AdminChecklistQuestionView';
import TaskList from './views/task-view/task-list-view/TaskList';
import WorkPlanView from './views/task-view/workplan-view/WorkPlanView';
import MapView from './views/task-view/map-view/MapView';
import useUserAccess from './hooks/useUserAccess';
import AdminPortalLinksView from './views/admin/admin-portal-links-view/AdminPortalLinksView';
import TechnicianTaskList from './views/task-view/technician-task-list-view/TechnicianTaskList';
import AdminNewsView from './views/admin/admin-news/AdminNewsView';
import AdminDepartments from './views/admin/admin-departments/AdminDepartmentsView';
import AdminUpdateTaskStatusView from './views/admin/admin-update-task-status/AdminUpdateTaskStatusView';
import DevInboxView from './views/dev/dev-integration-messages/DevInboxView';
import DevOutboxView from './views/dev/dev-integration-messages/DevOutboxView';

const UserRoleRoutes = () => {
  const { technicianUserGroupAllowed, officeUserGroupAllowed, adminUserGroupAllowed } = useUserAccess();

  return (
    <>
      {technicianUserGroupAllowed() && (
        <>
          <Route path={WORKPLAN_ROUTE + '/*'} element={<WorkPlanView />} />
          <Route path={CALENDAR_ROUTE + '/*'} element={<WorkPlanCalendarView />} />
          <Route path={TECHNICIAN_TASKLIST_ROUTE + '/*'} element={<TechnicianTaskList />} />
        </>
      )}

      {officeUserGroupAllowed() && (
        <>
          <Route path={TASKS_ROUTE + '/*'} element={<TaskList />} />
          <Route path={INTERNAL_TIME_OFFICE} element={<InternalTimeOfficeView />} />
          <Route path={MAP_TASK_LIST_ROUTE} element={<MapView />} />
        </>
      )}

      {adminUserGroupAllowed() && (
        <>
          <Route path={ADMIN_NEWS} element={<AdminNewsView />} />
          <Route path={ADMIN_DEPARTMENTS} element={<AdminDepartments />} />
          <Route path={ADMIN_TASKTYPES} element={<AdminTaskTypesView />} />
          <Route path={ADMIN_REUSABLECOMPONENTS} element={<AdminReusableComponentsView />} />
          <Route path={ADMIN_REASONCODES} element={<AdminReasonCodesView />} />
          <Route path={ADMIN_QUESTIONS} element={<AdminChecklistQuestionView />} />
          <Route path={ADMIN_PORTAL_LINKS} element={<AdminPortalLinksView />} />
          <Route path={ADMIN_UPDATE_TASK_STATUS} element={<AdminUpdateTaskStatusView />} />
        </>
      )}

      {/* Unlisted developer pages - no menu entry, you have to know the URL. */}
      {adminUserGroupAllowed() && (
        <>
          <Route path={DEV_INBOX} element={<DevInboxView />} />
          <Route path={DEV_OUTBOX} element={<DevOutboxView />} />
        </>
      )}
    </>
  );
};

export default UserRoleRoutes;
